import React, { ReactNode, useContext, useReducer } from 'react';
import Cookies from 'js-cookie';

import * as devConsole from '../dev-console';

export const UPDATE_COOKIES = 'UPDATE_COOKIES';

const initialState = Cookies.get();
interface UpdateCookies {
  type: typeof UPDATE_COOKIES;
  payload: typeof initialState;
}

type CookieActions = UpdateCookies;

const CookieContext = React.createContext(null);

const reducer = (state: typeof initialState, action: CookieActions): typeof initialState => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_COOKIES:
      return {
        ...state,
        ...payload,
      };
    default:
      devConsole.warn('Cookie Reducer:', type, 'is not a valid action type');
      return state;
  }
};

export const updateCookies = (cookies: typeof initialState): CookieActions => ({
  type: UPDATE_COOKIES,
  payload: cookies,
});

/* eslint-disable @typescript-eslint/no-unsafe-return */
export const useCookies = (): [typeof initialState, (action: CookieActions) => void] =>
  useContext(CookieContext);
/* eslint-enable @typescript-eslint/no-unsafe-return */

/* Side Effects */
export const setCookie = (
  dispatch: (action: CookieActions) => void,
  name: string,
  value: string | object,
  options?: Cookies.CookieAttributes
) => {
  Cookies.set(name, value, options);
  dispatch(updateCookies(Cookies.get()));
};

/**
 * CookieProvider allows us to use the `useCookies()` hook in multiple places.
 * Simply make sure that whichever component that uses useCookies() is nested
 * within the tree of <CookieProvider> and you are good to go.
 */
export function CookieProvider({ children }: { children: ReactNode }) {
  return (
    <CookieContext.Provider value={useReducer(reducer, initialState)}>{children}</CookieContext.Provider>
  );
}
